/* ---------------------------------- */

/*
 * 	SummerHouse
 * 	2019-03-19
 * 	Created by Conduit Studio (conduitstudio.com)
 * 	Written for Summerhouse (summerhouse.com)
 * 	Written by Aaron Vanderzwan
 *
 * 	application.js
 * 	Version 0.0.3
 *
 *  ---------------
 *
 *
 */


/* JSHint */
/* globals console */
/* jshint loopfunc: true, curly: false, freeze: false, esnext: true */


/* ---------------------------------- */

/* Caching */

var js_version = '0.0.2';
console.log('JS Version: ' + js_version);


/* ---------------------------------- */

/* Initialize */

jQuery(function($) {

  // Globals
  let _ = {
    // the_els = $holder.find('.css-grid').children(),
    $body: $('body'),
    $win: $(window),
    $holder: $('#holder'),
    $els: {}, // Add later

    // FXs
    do: {
      els_horiz_centering: function( $these ) {

        $these.each( function() {

          // Vars
          const $this = $(this),
            this_width = $this.width();

          // Ifs
          if( this_width > _.$win.w ) {

            // Center with negative left margin
            $this.css('margin-left', ( _.$win.w - this_width ) / 2 ).addClass('managed');

          } else if( $this.hasClass('managed') ) {

            // Cleanup
            $this.removeClass('managed').css('margin-left','auto');

          }

        });
      },
    }
  };

  // Update window obj
  _.$win.w = _.$win.width();
  _.$win.do = {
    load: function() {

      _.$win.trigger('resize.the_els');
      _.$body.addClass('winload-ready'); // <= let infinite->callback() know that images are ready
      if( _.$body.hasClass('infinite-ready') ) {
        _.$holder.addClass('in');
      }

    },
    resize: function() {

      // Update win_width
      _.$win.w = _.$win.width();

      // Center elements horizontally if they are wider than the $window
      _.do.els_horiz_centering( _.$holder.find('.logo') );

    },
  };

  // Listen for resize`
  _.$win.on( 'resize.the_els', _.$win.do.resize );


  // If already loaded, just run it
  if( document.readyState === 'complete' ) {
    _.$win.do.load();
  } else {
    _.$win.on( 'load.fadein', _.$win.do.load );
  }

  // Run infinite
  _.$body.infinite({
    init_offset: (122/1480) * _.$win.height(), // <= percent = 120px in a 1480px height (from design)
    callback: function() {

      // Get all of the elements
      _.$els = _.$holder.find('.css-grid').children();

      // We are ready
      _.$body.addClass('infinite-ready'); // <= let window->load() know that infinite is ready
      if( _.$body.hasClass('winload-ready') ) {
        _.$holder.addClass('in');
      }

    }
  });


});
